import { assert, isDefined } from '@sama/js-core';
import { ShapeState } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import {
  ShapeLocationOperationAttributes,
  UpsertShapeLocationOperation,
} from '../../../../../team-apis/otterdam/annotation-operations/shape-operations';
import { Output } from '../../../../../team-apis/otterdam/outputs/output';
import { ShapeLocationOperationBuilderParams } from './shape-operation-builder-params';

export function createUpsertShapeLocationBuilders({
  currentShape,
  output,
  locations,
}: ShapeLocationOperationBuilderParams) {
  return locations.map(
    (location) =>
      new UpsertShapeLocationOperationBuilder(
        location.frameNumber,
        output,
        location.operationAttributes,
        currentShape,
      ),
  );
}

// Export is needed to use objects with class type in other files
export class UpsertShapeLocationOperationBuilder {
  constructor(
    private frameNumber: number,
    private output: Output,
    private locationOperationAttributes?: ShapeLocationOperationAttributes,
    private shapeState?: ShapeState,
  ) {}

  canBuild() {
    return (
      isDefined(this.shapeState) && isDefined(this.locationOperationAttributes)
    );
  }

  build(): UpsertShapeLocationOperation {
    assert(this.shapeState, 'shape should be defined to upsert shape location');
    assert(
      this.locationOperationAttributes,
      'location operation attributes should be defined to upsert shape location',
    );

    return {
      operation: 'UPSERT_LOCATION',
      ids: { frameNumber: this.frameNumber, shapeId: this.shapeState.index },
      attributes: this.locationOperationAttributes,
      outputId: this.output.id,
    };
  }
}
